import { computed, ref, watch } from "vue";
import {} from "@/components/Datatypes/model";
import { terminalFactory } from "@/components/Workflow/Editor/modules/terminals";
import { useWorkflowStores } from "@/composables/workflowStores";
import {} from "@/stores/workflowStepStore";
export function useTerminal(stepId, terminalSource, datatypesMapper) {
    const terminal = ref(null);
    const stores = useWorkflowStores();
    const step = computed(() => stores.stepStore.getStep(stepId.value));
    const isMappedOver = computed(() => { var _a, _b; return (_b = (_a = stores.stepStore.stepMapOver[stepId.value]) === null || _a === void 0 ? void 0 : _a.isCollection) !== null && _b !== void 0 ? _b : false; });
    watch([step, terminalSource, datatypesMapper], () => {
        // rebuild terminal if any of the tracked dependencies change
        const newTerminal = terminalFactory(stepId.value, terminalSource.value, datatypesMapper.value, stores);
        newTerminal.getInvalidConnectedTerminals();
        terminal.value = newTerminal;
    }, {
        immediate: true,
    });
    return { terminal: terminal, isMappedOver };
}
